import React from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram, FaHeart, FaFacebook, FaYoutube } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Ben Sanga</h3>
          <p>Full-Stack Developer & Designer creating exceptional digital experiences.</p>
          <div className="social-links">
            <a href="https://github.com/sangaben" target="_blank" rel="noopener noreferrer">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/ben-sanga-a9b2032b1/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://x.com/sangatechug" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
            <a href="https://instagram.com/sangatech" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>

            <a href="https://facebook.com/sangaben" target="_blank" rel="noopener noreferrer">
              <FaFacebook />

            </a>

            <a href="https://www.youtube.com/@sangatechug" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
              </a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li>Web Development</li>
            <li>Graphic Design</li>
            <li>Web Hosting</li>
            <li>UI/UX Design</li>
            <li>Consulting</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Info</h4>
          <ul>
            <li>Email: sangaben07@gmail.com</li>
            <li>Phone: +256 766 670 007</li>
            <li>Location: Uganda</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {currentYear} Ben Sanga. All rights reserved. Built with <FaHeart className="heart-icon" /> using React & Django
        </p>
      </div>
    </footer>
  );
};

export default Footer;